<template>
    <div id="section-nav" class="bg-white" style="position:fixed;width:100%;z-index:999;"> 
        <nav class="flex relative self-auto items-center justify-between py-4 smx:mx-4 mx-6" >
            <a href="/" class="flex items-center flex-shrink-0 cursor-pointer text-white lg:ml-4">
                <img alt="logo oca" width="192" height="auto" src="../../assets/image/logo-oca.webp" class="logo-oca" >
            </a>
            <div class="menu-hide">
                <button @click="showMenu()" class="flex-grow items-center px-4 py-2 border rounded-md border-neutral-80 " >
                    <div class="text-customs-2 text-sm">Menu</div>
                </button>
            </div>
            <div class="flex-wrap menu-show lg:block lg:items-center lg:mt-0 mt-4 flex-1 justify-center pl-8">
                <div class="text-sm flex flex-wrap items-center">
                    <div @mouseenter="toggleNavbar('product')" @mouseleave="toggleNavbar('product')" class="relative inline-block mt-4 lg:mt-0">
                        <div :class="{'text-primary' : activeNavbar === 'product', 'text-neutral-300' : activeNavbar !== 'product' }" class="cursor-pointer select-none transition duration-300 ease-in-out mt-4 w-full lg:w-auto lg:mt-0 font-bold text-sm mx-6">
                            {{section_1?.product?.name}}
                        </div>
                        <div v-if="tabNavbar.product" data-aos="zoom-in-down" style="right: -100%;" class="absolute px-2 py-2 hidden w-78 lg:block z-50">
                            <div style="box-shadow: 0px -4px 15px rgba(0, 0, 0, 0.04), 0px 40px 50px rgba(0, 0, 0, 0.05);" class="flex flex-col bg-white shadow-xl rounded-lg px-4 py-4">
                                <div @click="goto('blast');" class="flex flex-row cursor-pointer hover:bg-complementer py-3 px-2 rounded-lg">
                                    <div class="flex flex-col">
                                        <div class="text-sm text-neutral-500 font-semibold">{{section_1?.product?.oca_blast?.title}}</div>
                                        <div class="text-xsm text-neutral-500">{{section_1?.product?.oca_blast?.description}}</div>
                                    </div>
                                </div>
                                <div @click="goto('interaction');" class="flex flex-row cursor-pointer hover:bg-complementer py-3 px-2 rounded-lg">
                                    <div class="flex flex-col">
                                        <div class="text-sm text-neutral-500 font-semibold">{{section_1?.product?.oca_interaction?.title}}</div>
                                        <div class="text-xsm text-neutral-500">{{section_1?.product?.oca_interaction?.description}}</div>
                                    </div>
                                </div>
                                <!-- <div @click="goto('whatsapp-api');" class="flex flex-row cursor-pointer hover:bg-complementer py-3 px-2 rounded-lg">
                                    <div class="flex flex-col">
                                        <div class="text-sm text-neutral-500 font-semibold">{{section_1?.product?.oca_whatsapp?.title}}</div>
                                        <div class="text-xsm text-neutral-500">{{section_1?.product?.oca_whatsapp?.description}}</div>
                                    </div>
                                </div> -->
                                <div @click="goto('bot-builder');" class="flex flex-row cursor-pointer hover:bg-complementer py-3 px-2 rounded-lg">
                                    <div class="flex flex-col">
                                        <div class="text-sm text-neutral-500 font-semibold">{{section_1?.product?.oca_chatbot?.title}}</div>
                                        <div class="text-xsm text-neutral-500">{{section_1?.product?.oca_chatbot?.description}}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div @mouseenter="toggleNavbar('solutions')" @mouseleave="toggleNavbar('solutions')" class="relative inline-block mt-4 lg:mt-0">
                        <div :class="{'text-primary' : activeNavbar === 'solutions', 'text-neutral-300' : activeNavbar !== 'solutions' }" class="cursor-pointer select-none transition duration-300 ease-in-out mt-4 w-full lg:w-auto lg:mt-0 font-bold text-sm mx-6">
                            {{section_1?.solution?.name}}
                        </div>
                        <div v-if="tabNavbar.solutions" data-aos="zoom-in-down" style="right: -100%;" class="absolute px-2 py-2 hidden w-78 lg:block z-50">
                            <div style="box-shadow: 0px -4px 15px rgba(0, 0, 0, 0.04), 0px 40px 50px rgba(0, 0, 0, 0.05);" class="flex flex-col bg-white shadow-xl rounded-lg px-4 py-4">
                                <div @click="goto('ukm');" class="flex flex-row cursor-pointer hover:bg-complementer py-3 px-2 rounded-lg">
                                    <div class="flex flex-col">
                                        <div class="text-sm text-neutral-500 font-semibold">{{section_1?.solution?.umkm?.title}}</div>
                                        <div class="text-xsm text-neutral-500">{{section_1?.solution?.umkm?.description}}</div>
                                    </div>
                                </div>
                                <!-- <div @click="goto('solutions/startup');" class="flex flex-row cursor-pointer hover:bg-complementer py-3 px-2 rounded-lg">
                                    <div class="flex flex-col">
                                        <div class="text-sm text-neutral-500 font-semibold">{{section_1?.solution?.startup?.title}}</div>
                                        <div class="text-xsm text-neutral-500">{{section_1?.solution?.startup?.description}}</div>
                                    </div>
                                </div> -->
                                <div @click="goto('enterprise');" class="flex flex-row cursor-pointer hover:bg-complementer py-3 px-2 rounded-lg">
                                    <div class="flex flex-col">
                                        <div class="text-sm text-neutral-500 font-semibold">{{section_1?.solution?.enterprise?.title}}</div>
                                        <div class="text-xsm text-neutral-500">{{section_1?.solution?.enterprise?.description}}</div>
                                    </div>
                                </div>
                                <div @click="goto('whatsapp-api');" class="flex flex-row cursor-pointer hover:bg-complementer py-3 px-2 rounded-lg">
                                    <div class="flex flex-col">
                                        <div class="text-sm text-neutral-500 font-semibold">{{section_1?.product?.oca_whatsapp?.title}}</div>
                                        <div class="text-xsm text-neutral-500">{{section_1?.product?.oca_whatsapp?.description}}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="relative inline-block mt-4 lg:mt-0"  >
                        <a href="/harga" :class="{'text-primary' : activeNavbar === 'pricing', 'text-neutral-300' : activeNavbar !== 'pricing' }" class="cursor-pointer select-none transition duration-300 ease-in-out mt-4 w-full lg:w-auto lg:mt-0 font-bold text-sm mx-6">
                            {{section_1?.pricing?.name}}
                        </a>
                    </div>

                    <div class="relative inline-block mt-4 lg:mt-0"  >
                        <a href="/partnership" :class="{'text-primary' : activeNavbar === 'partnership', 'text-neutral-300' : activeNavbar !== 'partnership' }" class="cursor-pointer select-none transition duration-300 ease-in-out mt-4 w-full lg:w-auto lg:mt-0 font-bold text-sm mx-6">
                            {{section_1?.partnership?.name}}
                        </a>
                    </div>
                    <div @mouseenter="toggleNavbar('resources')" @mouseleave="toggleNavbar('resources')" class="relative inline-block mt-4 lg:mt-0">
                        <div :class="{'text-primary' : activeNavbar === 'resources', 'text-neutral-300' : activeNavbar !== 'resources' }" class="cursor-pointer select-none transition duration-300 ease-in-out mt-4 w-full lg:w-auto lg:mt-0 font-bold text-sm mx-6">
                            {{section_1?.resources?.name}}
                        </div>
                        <div v-if="tabNavbar.resources" data-aos="zoom-in-down" style="right: -100%;" class="absolute px-2 py-2 hidden w-78 lg:block z-50">
                            <div style="box-shadow: 0px -4px 15px rgba(0, 0, 0, 0.04), 0px 40px 50px rgba(0, 0, 0, 0.05);" class="flex flex-col bg-white shadow-xl rounded-lg px-4 py-4">
                                <!-- <div @click="goto('resources');" class="flex flex-row cursor-pointer hover:bg-complementer py-3 px-2 rounded-lg">
                                    <div class="flex flex-col">
                                        <div class="text-sm text-neutral-500 font-semibold">{{section_1?.resources?.faq?.title}}</div>
                                        <div class="text-xsm text-neutral-500">{{section_1?.resources?.faq?.description}}</div>
                                    </div>
                                </div> -->
                                <a href="https://ocaindonesia.co.id/blog/" class="flex flex-row cursor-pointer hover:bg-complementer py-3 px-2 rounded-lg">
                                    <div class="flex flex-col">
                                        <div class="text-sm text-neutral-500 font-semibold">{{section_1?.resources?.blog?.title}}</div>
                                        <div class="text-xsm text-neutral-500">{{section_1?.resources?.blog?.description}}</div>
                                    </div>
                                </a>
                                <a href="https://docs.ocaindonesia.co.id/product-documentation" class="flex flex-row cursor-pointer hover:bg-complementer py-3 px-2 rounded-lg">
                                    <div class="flex flex-col">
                                        <div class="text-sm text-neutral-500 font-semibold">{{section_1?.resources?.documentation?.title}}</div>
                                        <div class="text-xsm text-neutral-500">{{section_1?.resources?.documentation?.description}}</div>
                                    </div>
                                </a>
                            </div>
                        </div>
                    </div>
                    <div class="relative inline-block mt-4 lg:mt-0"  >
                        <a href="/about-us" :class="{'text-primary' : activeNavbar === 'about-us', 'text-neutral-300' : activeNavbar !== 'about-us' }" class="cursor-pointer select-none transition duration-300 ease-in-out mt-4 w-full lg:w-auto lg:mt-0 font-bold text-sm mx-6">
                            {{section_1?.about?.name}}
                        </a>
                    </div>

                </div>
            </div>
            <div class="flex lg:block lg:items-center lg:mt-0 mt-4 menu-show">
                <div class="text-sm flex items-center pl-8">
                    
                    <!-- Multi Language -->
                    <div class="relative">
                        <div @click="openMultiLanguage()" class="flex flex-row cursor-pointer mr-4">
                            <svg class="self-center" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M14.2733 5.76C14.2733 5.76 14.2733 5.76 14.2733 5.72667C13.8036 4.44415 12.9512 3.33686 11.8316 2.55458C10.712 1.7723 9.37913 1.35278 8.0133 1.35278C6.64747 1.35278 5.31459 1.7723 4.19497 2.55458C3.07536 3.33686 2.22303 4.44415 1.7533 5.72667C1.7533 5.72667 1.7533 5.72667 1.7533 5.76C1.22872 7.20727 1.22872 8.79274 1.7533 10.24C1.7533 10.24 1.7533 10.24 1.7533 10.2733C2.22303 11.5559 3.07536 12.6631 4.19497 13.4454C5.31459 14.2277 6.64747 14.6472 8.0133 14.6472C9.37913 14.6472 10.712 14.2277 11.8316 13.4454C12.9512 12.6631 13.8036 11.5559 14.2733 10.2733C14.2733 10.2733 14.2733 10.2733 14.2733 10.24C14.7979 8.79274 14.7979 7.20727 14.2733 5.76ZM2.83997 9.33334C2.60879 8.45948 2.60879 7.54053 2.83997 6.66667H4.07997C3.97332 7.55236 3.97332 8.44765 4.07997 9.33334H2.83997ZM3.38663 10.6667H4.31997C4.47645 11.2612 4.70011 11.836 4.98663 12.38C4.33283 11.9346 3.7863 11.3494 3.38663 10.6667ZM4.31997 5.33334H3.38663C3.78055 4.65273 4.3201 4.06765 4.96663 3.62C4.687 4.16483 4.47006 4.73961 4.31997 5.33334ZM7.3333 13.1333C6.51448 12.5325 5.9394 11.6568 5.7133 10.6667H7.3333V13.1333ZM7.3333 9.33334H5.42663C5.30223 8.4488 5.30223 7.5512 5.42663 6.66667H7.3333V9.33334ZM7.3333 5.33334H5.7133C5.9394 4.34318 6.51448 3.46755 7.3333 2.86667V5.33334ZM12.6133 5.33334H11.68C11.5235 4.73877 11.2998 4.16396 11.0133 3.62C11.6671 4.06538 12.2136 4.65063 12.6133 5.33334ZM8.66663 2.86667C9.48546 3.46755 10.0605 4.34318 10.2866 5.33334H8.66663V2.86667ZM8.66663 13.1333V10.6667H10.2866C10.0605 11.6568 9.48546 12.5325 8.66663 13.1333ZM10.5733 9.33334H8.66663V6.66667H10.5733C10.6977 7.5512 10.6977 8.4488 10.5733 9.33334ZM11.0333 12.38C11.3198 11.836 11.5435 11.2612 11.7 10.6667H12.6333C12.2336 11.3494 11.6871 11.9346 11.0333 12.38ZM13.16 9.33334H11.92C11.9742 8.89097 12.0009 8.44567 12 8C12.0007 7.55434 11.974 7.10905 11.92 6.66667H13.16C13.3911 7.54053 13.3911 8.45948 13.16 9.33334Z" fill="#5E6C84"/>
                            </svg>
                            <span class="text-neutral-300 font-bold text-sm select-none transition duration-300 ease-in-out mx-2">{{currLanguage === 'id' ? 'ID' : 'EN'}}</span>
                            <svg class="self-center" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M4 6L8 10L12 6" stroke="#5E6C84" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </div>
                        <div v-if="isMultiLanguage" @click="handleMultiLanguage()" class="flex flex-row cursor-pointer absolute">
                            <svg class="self-center" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M14.2733 5.76C14.2733 5.76 14.2733 5.76 14.2733 5.72667C13.8036 4.44415 12.9512 3.33686 11.8316 2.55458C10.712 1.7723 9.37913 1.35278 8.0133 1.35278C6.64747 1.35278 5.31459 1.7723 4.19497 2.55458C3.07536 3.33686 2.22303 4.44415 1.7533 5.72667C1.7533 5.72667 1.7533 5.72667 1.7533 5.76C1.22872 7.20727 1.22872 8.79274 1.7533 10.24C1.7533 10.24 1.7533 10.24 1.7533 10.2733C2.22303 11.5559 3.07536 12.6631 4.19497 13.4454C5.31459 14.2277 6.64747 14.6472 8.0133 14.6472C9.37913 14.6472 10.712 14.2277 11.8316 13.4454C12.9512 12.6631 13.8036 11.5559 14.2733 10.2733C14.2733 10.2733 14.2733 10.2733 14.2733 10.24C14.7979 8.79274 14.7979 7.20727 14.2733 5.76ZM2.83997 9.33334C2.60879 8.45948 2.60879 7.54053 2.83997 6.66667H4.07997C3.97332 7.55236 3.97332 8.44765 4.07997 9.33334H2.83997ZM3.38663 10.6667H4.31997C4.47645 11.2612 4.70011 11.836 4.98663 12.38C4.33283 11.9346 3.7863 11.3494 3.38663 10.6667ZM4.31997 5.33334H3.38663C3.78055 4.65273 4.3201 4.06765 4.96663 3.62C4.687 4.16483 4.47006 4.73961 4.31997 5.33334ZM7.3333 13.1333C6.51448 12.5325 5.9394 11.6568 5.7133 10.6667H7.3333V13.1333ZM7.3333 9.33334H5.42663C5.30223 8.4488 5.30223 7.5512 5.42663 6.66667H7.3333V9.33334ZM7.3333 5.33334H5.7133C5.9394 4.34318 6.51448 3.46755 7.3333 2.86667V5.33334ZM12.6133 5.33334H11.68C11.5235 4.73877 11.2998 4.16396 11.0133 3.62C11.6671 4.06538 12.2136 4.65063 12.6133 5.33334ZM8.66663 2.86667C9.48546 3.46755 10.0605 4.34318 10.2866 5.33334H8.66663V2.86667ZM8.66663 13.1333V10.6667H10.2866C10.0605 11.6568 9.48546 12.5325 8.66663 13.1333ZM10.5733 9.33334H8.66663V6.66667H10.5733C10.6977 7.5512 10.6977 8.4488 10.5733 9.33334ZM11.0333 12.38C11.3198 11.836 11.5435 11.2612 11.7 10.6667H12.6333C12.2336 11.3494 11.6871 11.9346 11.0333 12.38ZM13.16 9.33334H11.92C11.9742 8.89097 12.0009 8.44567 12 8C12.0007 7.55434 11.974 7.10905 11.92 6.66667H13.16C13.3911 7.54053 13.3911 8.45948 13.16 9.33334Z" fill="#5E6C84"/>
                            </svg>
                            <span class="text-neutral-300 font-bold text-sm select-none transition duration-300 ease-in-out mx-2">{{currLanguage === 'id' ? 'EN' : 'ID'}}</span>
                            <svg class="self-center invisible" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M4 6L8 10L12 6" stroke="#5E6C84" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </div>
                    </div>

                    <div v-if="!isLoggedIn" class="relative inline-block mt-4 lg:mt-0">
                        <a id="link-login-nav" :href="portalUrl" target="_blank" class="cursor-pointer select-none text-neutral-300 transition duration-300 ease-in-out mt-4 w-full lg:w-auto lg:mt-0 font-bold text-sm mr-8">
                            {{section_1?.button_login}}
                        </a>
                    </div>
                    <oca-button v-if="!isLoggedIn" id="btn-freetrial-nav" @click="gotoHref(`${portalUrl}/register`)" classValue="rounded-md text-sm font-bold">
                        {{section_1?.button_signup}}
                    </oca-button>
                    <div class="relative inline-block" @mouseenter="toggleNavbar('profile')" @mouseleave="toggleNavbar('profile')">
                        <oca-button v-if="isLoggedIn" class="px-3 py-2 font-bold" classValue="rounded-md" buttonType="ghost" style="max-width: 180px">
                            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" style="min-width: 16px; min-height: 16px; margin-top: 2px">
                                <path d="M10 10.5V9.5C10 8.96957 9.78929 8.46086 9.41421 8.08579C9.03914 7.71071 8.53043 7.5 8
                                7.5H4C3.46957 7.5 2.96086 7.71071 2.58579 8.08579C2.21071 8.46086 2 8.96957 2 9.5V10.5"
                                stroke="#E81255" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M6 5.5C7.10457 5.5 8 4.60457 8 3.5C8 2.39543 7.10457 1.5 6 
                                1.5C4.89543 1.5 4 2.39543 4 3.5C4 4.60457 4.89543 5.5 6 5.5Z" 
                                stroke="#E81255" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                            <div class="px-3 clip-ellipsis">{{loggedData?.name}}</div> 
                            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" style="min-width: 16px; min-height: 16px; margin-top: 2px">
                                <path d="M3 4.5L6 7.5L9 4.5" stroke="#E81255" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </oca-button>
                        <div v-if="tabNavbar.profile" data-aos="zoom-in-down" class="absolute hidden lg:block w-48 z-50 pt-4" style="right: 5%">
                            <div style="box-shadow: 0px -4px 15px rgba(0, 0, 0, 0.04), 0px 40px 50px rgba(0, 0, 0, 0.05);" class="bg-white shadow-xl rounded-lg px-4 py-4">
                                <div class="py-3 px-2 w-full font-semibold flex rounded-lg items-center cursor-pointer hover:bg-complementer" @click="gotoHomeDashboard()">
                                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <g clip-path="url(#clip0_8544_6504)">
                                        <path d="M1.5 4.5L6 1L10.5 4.5V10C10.5 10.2652 10.3946 10.5196 10.2071 10.7071C10.0196 10.8946 9.76522 11 9.5 11H2.5C2.23478 11 1.98043 10.8946 1.79289 10.7071C1.60536 10.5196 1.5 10.2652 1.5 10V4.5Z" stroke="#6B778C" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M4.5 11V6H7.5V11" stroke="#6B778C" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
                                        </g>
                                        <defs>
                                        <clipPath id="clip0_8544_6504">
                                        <rect width="12" height="12" fill="white"/>
                                        </clipPath>
                                        </defs>
                                    </svg>
                                    <div class="ml-2 text-neutral-200">Go to Dashboard</div>
                                </div>
                                <div class="mx-2 my-2" style="height: 1px; background-color: #EBECF0"></div>
                                <div class="py-3 px-2 w-full flex items-center rounded-lg font-semibold cursor-pointer hover:bg-complementer" @click="fetchLogout()">
                                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <g clip-path="url(#clip0_8544_6509)">
                                        <path d="M4.5 10.5H2.5C2.23478 10.5 1.98043 10.3946 1.79289 10.2071C1.60536 10.0196 1.5 9.76522 1.5 9.5V2.5C1.5 2.23478 1.60536 1.98043 1.79289 1.79289C1.98043 1.60536 2.23478 1.5 2.5 1.5H4.5" stroke="#E81255" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M8 8.5L10.5 6L8 3.5" stroke="#E81255" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M10.5 6H4.5" stroke="#E81255" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
                                        </g>
                                        <defs>
                                        <clipPath id="clip0_8544_6509">
                                        <rect width="12" height="12" fill="white"/>
                                        </clipPath>
                                        </defs>
                                    </svg>
                                    <div class="pl-2 text-primary">Logout</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                </div>
            </div>
        </nav>
    </div>
</template>
<script>
import { APP_LAYOUT } from "../../app-settings/home";
import OcaButton from './buttons';

export default {
    name: 'App',
    data: function () {
      return {
        textParam: '',
        portalUrl: process.env.VUE_APP_PORTAL_URL,
        listData: {},
        section_1: {},
        footer: {},
        tabNavbar: {
            product: false,
            solutions: false, 
            pricing: false,
            resources: false,
            aboutus: false,
            profile: false
        },
        newsShow: true,
        isMultiLanguage: false,
        currLanguage: localStorage.getItem('lang'),
        konten: {},
        ListNav: {
            EN : [],
            ID : []
        },
        activeNavbar: '',
        isLoggedIn: false,
        loggedData: null
      }
    },
    components: {
        OcaButton,
    },
    mounted() {
        this.textParam = window.location.href.split('?').length > 1 ? '?' + window.location.href.split('?')[1] : '';
        this.listData = APP_LAYOUT
        this.getCopyNavbar();
        this.getVersionContactUs();
        this.currLanguage = localStorage.getItem('lang') === null ? 'en' : localStorage.getItem('lang');
        switch (window.location.pathname.replace('en/', '').replace('id/', '').split('/')[1]) {
            case 'blast':
            case 'interaction':
            case 'bot-builder':
            case 'product':
                this.activeNavbar = 'product'
                break;

            case 'ukm':
            case 'enterprise':
            case 'whatsapp-api':
            case 'solutions':
                this.activeNavbar = 'solutions'
                break;

            case 'harga':
                this.activeNavbar = 'pricing'
                break;

            case 'partnership':
                this.activeNavbar = 'partnership'
                break;
                
            case 'resources':
                this.activeNavbar = 'resources'
                break;

            case 'blog':
                this.activeNavbar = 'resources'
                break;

            case 'blog_detail':
                this.activeNavbar = 'resources'
                break;
        
            case 'about-us':
                this.activeNavbar = 'about-us'
                break;

            default:
                break;
        }

        if (this.currLanguage === 'id') {
            this.section_1 = this.listData.header_id
            this.footer = this.listData.footer_id
        }
        else if (this.currLanguage === 'en') {
            this.section_1 = this.listData.header_eng
            this.footer = this.listData.footer_eng
        }
        else {
            this.section_1 = this.listData.header_id
            this.footer = this.listData.footer_id
            localStorage.setItem('lang', 'en')
        }
        this.checkLoginSession()
    },
    methods: {
        newsShowMobile: function () {
            this.newsShow = !this.newsShow
        },
        showMenu: function () {
            this.$parent.menuShowMobile()
        },
        gotoDashboard(url){
            if (window.location.pathname === '/harga') {
                window.open('https://dashboard.ocaindonesia.co.id/account/' + url);
            } else {
                this.goto('harga')
            }
            
        },
        gotoHomeDashboard(){
            // window.location.href = 'https://home.ocaindonesia.co.id/home'
            window.open('https://home.ocaindonesia.co.id//home')
        },
        gotoHref: function (url) {
            window.location.href = url;
        },
        goto: function (url) {
            window.location.assign(`${window.location.protocol}//${window.location.host}/${url}${this.textParam}`)
        },
        gotoWa(){
            window.open('https://api.whatsapp.com/message/CJYNUR2AAUSVG1','_blank');
        },
        openMultiLanguage: function() {
            this.isMultiLanguage = !this.isMultiLanguage;
        },
        handleMultiLanguage: function() {
            this.currLanguage = this.currLanguage === 'id' ? 'en' : 'id';
            localStorage.setItem('lang', this.currLanguage)
            this.isMultiLanguage = false;
            // let parseUrl = this.currLanguage === 'en' ? 'en' + window.location.pathname : window.location.pathname === '/en' ? '' : window.location.pathname.replace('/en/', '');
            // if (parseUrl[0] === '/') parseUrl = parseUrl.slice(1);
            // if (parseUrl[parseUrl.length - 1] === '/') parseUrl = parseUrl.slice(0, parseUrl.length - 1);
            // window.location.assign(`${window.location.protocol}//${window.location.host}/${parseUrl}`);
            // console.log(window.location.host, parseUrl, window.location.pathname, this.currLanguage);
            // console.log(`${window.location.protocol}//${window.location.host}/${parseUrl}`);
            
            window.location.reload()
        },
        toggleNavbar: function (val) {
            switch (val) {
                case 'product':
                    this.tabNavbar.product = !this.tabNavbar.product
                    this.tabNavbar.solutions = false
                    this.tabNavbar.pricing = false
                    this.tabNavbar.resources = false
                    this.tabNavbar.aboutus = false
                    this.tabNavbar.profile = false
                    break;
                case 'solutions':
                    this.tabNavbar.product = false
                    this.tabNavbar.solutions = !this.tabNavbar.solutions
                    this.tabNavbar.pricing = false
                    this.tabNavbar.resources = false
                    this.tabNavbar.aboutus = false
                    this.tabNavbar.profile = false
                    break;
                case 'pricing':
                    this.tabNavbar.product = false
                    this.tabNavbar.solutions = false
                    this.tabNavbar.pricing = !this.tabNavbar.pricing
                    this.tabNavbar.resources = false
                    this.tabNavbar.aboutus = false
                    this.tabNavbar.profile = false
                    break;
                case 'resources':
                    this.tabNavbar.product = false
                    this.tabNavbar.solutions = false
                    this.tabNavbar.pricing = false
                    this.tabNavbar.resources = !this.tabNavbar.resources
                    this.tabNavbar.aboutus = false
                    this.tabNavbar.profile = false
                    break;
                case 'aboutus':
                    this.tabNavbar.product = false
                    this.tabNavbar.solutions = false
                    this.tabNavbar.pricing = false
                    this.tabNavbar.resources = false
                    this.tabNavbar.aboutus = !this.tabNavbar.aboutus
                    this.tabNavbar.profile = false
                    break;
                case 'profile':
                    this.tabNavbar.product = false
                    this.tabNavbar.solutions = false
                    this.tabNavbar.pricing = false
                    this.tabNavbar.resources = false
                    this.tabNavbar.aboutus =  false
                    this.tabNavbar.profile = !this.tabNavbar.profile
                    break;
                default:
                    break;
            }
        },
        modalNavbarMobile: function () {
            this.$modal.show('error', {
                title: "ERROR 123",
                message: "messages 123",
            }) 
        },
        getVersionContactUs: function() {
            if (window.location.pathname.includes('hubungi-kami')) return;
            const axios = require('axios')
            axios.get(process.env.VUE_APP_CONTACT_US_VERSION_URL)
                .then(function (response) {
                    localStorage.setItem('c_version', response.data.data)
                })
        },
        getCopyNavbar: function() {
            const axios = require('axios')

            let main = this
            let url = `https://cms.ocaindonesia.co.id/wp-json/wp/v2/oca_dtp?slug=navigation-bar`
            axios.get(url)
                .then(function (response) {
                    main.konten = response.data[0].acf
                    main.ListNav.EN = response.data[0].acf.en_list_item.split('|');
                    main.ListNav.ID = response.data[0].acf.id_list_item.split('|')
                    // main.ListNav.EN = 
                })
        },
        checkLoginSession(){
             if(!this.$cookies.isKey("oca-dasureat")){
                this.isLoggedIn = false
            } else {
                this.isLoggedIn = true
                this.loggedData = JSON.parse(window.atob(this.$cookies.get("oca-dasureat")));
            }
        },
        async fetchLogout(){
            this.delete_cookie('oca-dasureat');
            this.delete_cookie('oca-juster');
            this.delete_cookie('oca-rebnumyfirev');
            this.delete_cookie('oca-ferrule');
            location.reload()
        },
        get_cookie(name){
            return document.cookie.split(';').some(c => {
                return c.trim().startsWith(name + '=');
            });
        },
         delete_cookie( name ) {
            let path = '/'

            let domain = '.ocaindonesia.co.id'

            if( this.get_cookie( name ) ) {
                document.cookie = name + "=" + ";path="+path+ ";domain="+domain + ";expires=Thu, 01 Jan 1970 00:00:01 GMT";
            }
        }
    }
}
</script>

<style>

.logo-oca {
    height: auto;
    width: 12rem;
}
.menu-hide {
    display: none;
}
.menu-show {
    display: flex;
}
.clip-ellipsis{
    max-width: 180px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
}

@media (min-width:320px) and (max-width:600px)  { 
    .logo-oca {
        height: auto;
        width: 10rem;
    }
    .menu-hide {
        display: block !important;
    }
    .menu-show {
        display: none !important;
    }
    .mobile-view {
      display: flex;
    }

    .desktop-view {
      display: none;
    }
}
@media (min-width:600px)  { 
    /* portrait tablets, portrait iPad, e-readers (Nook/Kindle), landscape 800x480 phones (Android) */ 
    .logo-oca {
        height: auto;
        width: 10rem;
    }
    .menu-hide {
        display: block !important;
    }
    .menu-show {
        display: none !important;
    }
    .mobile-view {
      display: flex;
    }

    .desktop-view {
      display: none;
    }
}
@media (min-width:801px)  { 
    /* tablet, landscape iPad, lo-res laptops ands desktops */ 
    .logo-oca {
        height: auto;
        width: 12rem;
    }
    .menu-hide {
        display: block !important;
    }
    .menu-show {
        display: none !important;
    }
    .mobile-view {
        display: none !important;
    }

    .desktop-view {
        display: flex;
    }
}
@media (min-width:1025px) { 
  /* big landscape tablets, laptops, and desktops */ 
    .logo-oca {
        height: auto;
        width: 12rem;
    }
    .menu-hide {
        display: none !important;
    }
    .menu-show {
        display: flex !important;
    }
    .mobile-view {
        display: none !important;
    }

    .desktop-view {
        display: flex;
    }
}
@media (min-width:1281px) { 
  /* hi-res laptops and desktops */
    .logo-oca {
        height: auto;
        width: 12rem;
    } 

    .menu-hide {
        display: none !important;
    }
    .menu-show {
        display: flex !important;
    }
    .mobile-view {
        display: none;
    }

    .desktop-view {
        display: flex;
    }
}

</style>